import React from "react";
import classes from "./MainPage.module.css"
import Meeting from "./Meeting/Meeting";
import AdvSec from "./AdvSec/AdvSec";
import Catalog from "./Catalog/Catalog";
import About from "./About/About";
import Contact from "./Сontact/Contact"

const MainPage = () => {
    return (
        <div className={classes.MainPage}>
            <Meeting/>
            <AdvSec/>
            <Catalog/>
            <About/>
            <Contact/>
        </div>
    )
}

export default MainPage